
import { DossierConfigService } from "@/services";
import { ChartService, IYearOverviewPerMonthResult } from "@/services/chart-service";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { DashboardYearOverviewPerMonthData } from "@/utils/dashboard/dashboard-year-overview-per-month-data";
import { printHumanFloatDashboard } from "@/utils/pretty-print";
import {AppApexChart} from "@/utils/apex-charts";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			data: new DashboardYearOverviewPerMonthData(),
			result: [] as IYearOverviewPerMonthResult[],
			printModal: false
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
	},
	computed: {
		chartOptions():any {
			return this.getChartOptions();
		},
		startMonth():number {
			return DossierConfigService.getGeneralConfig().BookYearStartMonth;
		},
		chartType():string{
			return "bar";
		},
		displayData():any[] {
			let income:number[] = [];
			let cost:number[] = [];
			let profit:number[] = [];
			for (let item of this.result){
				income.push(parseFloat(this.printNum(item.income)));
				cost.push(parseFloat(this.printNum(item.cost)));
				profit.push(parseFloat(this.printNum(item.difference)));
			}
			return [
				{
					data: income,
					name: "Opbrensten"
				},
				{
					data: cost,
					name: "Kosten"
				},
				{
					data: profit,
					name: "Verschil"
				}
			];
		},
		printChartOptions():any {
			let options = this.getChartOptions();
			options.chart.animations = {enabled: false};
			return options;
		}
	},
	watch: {
		item: {
			immediate: true,
			handler(){
				if (!this.item.Data){
					this.data = new DashboardYearOverviewPerMonthData();
					return;
				}
				this.data = new DashboardYearOverviewPerMonthData(this.item.Data.getJSON());
			}
		}
	},
	methods: {
		// eslint-disable-next-line max-lines-per-function
		getChartOptions():any{
			let months = [] as string[];
			for (let i = 0; i < 12; i++) {
				let monthNumber = i + 1 + this.startMonth;
				if (monthNumber > 12) {
					monthNumber -= 12;
				}
				months.push(this.$ct("common.months." + monthNumber).toString().substring(0, 3));
			}

			let dataLabelOptions = {
				enabled: false,
			};

			return {
				chart: {
					toolbar: {
						show: false
					},
				},
				grid: {},
				yaxis: {},
				stroke: {},
				plotOptions: {
					bar: {
						dataLabels: {
							position: "top"
						}
					}
				},
				dataLabels: dataLabelOptions,
				xaxis: {
					categories: months,
					crosshairs: {show: false},
					axisBorder: {
						show: false
					},
					axisTicks: {color: "#ededed"},
					labels: {
						style: {
							fontFamily: "Arial",
							fontSize: "14px",
							"-webkit-font-smoothing": "antialiased"
						}
					}
				},
			};
		},
		close(){
			this.$emit("close");
		},
		confirm(){
			this.item.Data = this.data;
			this.$emit("confirm", this.item);
			this.close();
		},
		async fetch(){
			this.result = await ChartService.getYearOverviewPerMonth(this.data.incomeFilters, this.data.costFilters, this.data.getBookYearOverrideValue());
		},
		printNum(num:number):string{
			return printHumanFloatDashboard(num);
		},
		print(){
			this.printModal = true;
			setTimeout(()=>{
				if (!this.$refs.printChart) return;
				let w = window.open("", "PRINT", "widht=600px,height=400px");
				if (!w) return;
				console.log((this.$refs.printChart as HTMLDivElement).outerHTML);
				w.document.write(`<html><head></head><body>`);
				w.document.write((this.$refs.printChart as HTMLDivElement).innerHTML);
				w.document.write("</body></html>");
				w.focus();
				w.print();
				w.close();
			}, 1000);
			setTimeout(()=>{
				this.printModal = false;
			}, 2000);
		}
	},
	created(){
		this.fetch();
	},
	components: {
		AppApexChart

	},
	i18nEx: {
		componentPrefix: "components.dashboard"
	}
});
